import { VoidFunctionComponent } from "react";
import cn from "classnames";
import styles from "./NavIllustration.module.scss";
import { NavIllustrationProps } from "./NavIllustration.props";

/**
 * The navigation item illustration component.
 */
export const NavIllustration: VoidFunctionComponent<NavIllustrationProps> = (props: NavIllustrationProps) => {
  const { id, testId, className, illustration: Illustration } = props;
  const navIllustrationClasses = cn("nav-illustration", styles.navIllustration, className);

  return (
    <div id={id} data-testid={testId ? `test__${testId}-nav-illustration` : undefined} className={navIllustrationClasses}>
      <Illustration />
    </div>
  );
};
